import React, { useEffect, useState } from 'react';
import { Box } from '@mui/material';
import { useDispatch } from 'react-redux';
import { Drawer, drawerType } from '../../../../packages/ui/organisms/drawer';
import StepThreePharmacy from '../add-new-report/step-three-pharmacy/StepThreePharmacy';
import { profileActionCreators } from '../../../../redux/modules/profile';

const EditPharmacyDrawer = ({ open, onClose, selectedPharmacy, demographicDetails, memberId }) => {
  const dispatch = useDispatch();
  const [selectedPharmacyDetails, setSelectedPharmacyDetails] = useState(null);

  useEffect(() => {
    if (open && selectedPharmacy) {
      setSelectedPharmacyDetails(selectedPharmacy);
    }
  }, [open, selectedPharmacy]);

  const handleClose = () => {
    setSelectedPharmacyDetails(null);
    onClose();
  };

  const handleSave = () => {
    if (!selectedPharmacyDetails || !memberId) return;

    dispatch(
      profileActionCreators.updateDemographicDetails({
        demographicDetails: {
          ...demographicDetails,
          preferredPharmacy: selectedPharmacyDetails.id,
        },
        memberId,
      }),
    );

    dispatch(profileActionCreators.fetchDemographicDetails(memberId));
    handleClose();
  };

  return (
    <Drawer
      open={open}
      onClose={handleClose}
      variant={drawerType.FORM}
      title="Edit Pharmacy"
      submitBtnTitle="Save"
      onSubmit={handleSave}
      disableSubmit={!selectedPharmacyDetails}
      sx={{
        '& .drawerBody': {
          padding: '24px !important',
        },
      }}
    >
      <Box>
        <StepThreePharmacy
          selectedPharmacy={selectedPharmacyDetails}
          onPharmacySelect={setSelectedPharmacyDetails}
          zipCode={demographicDetails?.preferredPharmacyZipCode}
          memberPreferredPharmacy={demographicDetails?.preferredPharmacy}
        />
      </Box>
    </Drawer>
  );
};

export default EditPharmacyDrawer;
